<template>
  <div>
    <Banner value="Calendário Escolar"/>

    <section style="background:#DDD">
      <v-container grid-list-xl>
        <v-layout row wrap my-2>
          <v-flex xs12>
            <p class="lead">Clique para visualizar o calendário do ano escolhido:</p>
          </v-flex>
        </v-layout>
      </v-container>
    </section>

    <v-container grid-list-lg>
      <v-layout row wrap my-4>
        <v-flex xs6 v-for="(c, i) in $store.state.calendarios" :key="i">
          <v-hover>
            <v-btn
              v-if="!c.message"
              slot-scope="{ hover }"
              :class="`elevation-${hover ? 12 : 2}`"
              round
              :color="c.color"
              dark
              large
              block
              :href="c.link"
              :target="c.link.substring(0, 10) === 'javascript' ? '' : '_blank'"
              style="padding-top:150px;padding-bottom:150px;text-align:center;"
            >
              <div>
                <v-icon style="font-size:70px;">{{c.icon}}</v-icon>
                <span style="display:block; font-size:1.68em; margin-top:10px;">Calendário</span>
                <span style="display:block; font-size:3.23em">{{c.text}}</span>
                <small style="display:block; font-size:3.23em">{{c.message}}</small>
              </div>
            </v-btn>
            <v-btn
              v-else
              slot-scope="{ hover }"
              :class="`elevation-${hover ? 12 : 2}`"
              round
              :color="c.color"
              dark
              large
              block
              :href="c.link"
              style="padding-top:150px;padding-bottom:150px;text-align:center;"
            >
              <div>
                <v-icon style="font-size:70px;">{{c.icon}}</v-icon>
                <span style="display:block; font-size:1.68em; margin-top:10px;">Calendário</span>
                <span style="display:block; font-size:3.23em">{{c.text}}</span>
                <small style="display:block; font-size:1rem">{{c.message}}</small>
              </div>
            </v-btn>
          </v-hover>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import Banner from "../../components/Banner";

export default {
  data: () => ({}),
  components: {
    Banner
  }
};
</script>

<style lang="scss" scoped>
</style>

